import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { ISiteDesign } from '@fi-shared/models';
import { FiImageSize } from '@fi-shared/types';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';

@Component({
    selector: 'fi-site-design-access-item',
    templateUrl: './fi-site-design-access-item.component.html',
    styleUrls: ['./fi-site-design-access-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-site-design-access-item' },
    standalone: false,
})
export class FiSiteDesignAccessItemComponent implements OnInit {
    @Input() siteDesignIds: number[];
    @Input() fiInfoPosition: string = 'top';

    readonly siteDesignLogoLeftOffset: number = 29;
    readonly siteDesignLogoWidth: number = 40;
    readonly maxDisplayedSiteDesigns: number = 3;
    FiProfileSizes = FiProfileSizes;
    FiImageSize = FiImageSize;

    constructor(
        private userDataService: FiUserDataService,
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit(): void {
        this.setContainerWidth();
    }

    setContainerWidth() {
        this.renderer.setStyle(this.elementRef.nativeElement, 'width', `${this.getContainerWidth()}px`);
    }

    getContainerWidth(): number {
        if (this.isAdditionalBadgeShown())
            return this.siteDesignLogoWidth + this.maxDisplayedSiteDesigns * this.siteDesignLogoLeftOffset;

        const displayedSiteDesigns = this.getDisplayedSiteDesigns();
        return this.siteDesignLogoWidth + (displayedSiteDesigns.length - 1) * this.siteDesignLogoLeftOffset;
    }

    getSiteDesigns(): ISiteDesign[] {
        const siteDesigns = this.userDataService.getAvailableSiteDesigns().filter((siteDesign) => {
            return this.siteDesignIds.indexOf(siteDesign.Id) !== -1;
        });
        return siteDesigns;
    }

    getDisplayedSiteDesigns(): ISiteDesign[] {
        const displayedSiteDesigns = this.getSiteDesigns();
        if (this.isAdditionalBadgeShown()) {
            displayedSiteDesigns.length = this.maxDisplayedSiteDesigns;
        }
        return displayedSiteDesigns;
    }

    getProfileDataFromSiteDesign(siteDesign: ISiteDesign): IUserProfile {
        return {
            Id: undefined,
            FullName: siteDesign.Name,
            MediaBankPhysicalFileName: siteDesign.LogoReference?.PhysicalFileName,
            MediaBankExtension: siteDesign.LogoReference?.Extension,
        };
    }

    isAdditionalBadgeShown(): boolean {
        return this.getSiteDesigns().length > this.maxDisplayedSiteDesigns;
    }

    getHiddenSiteDesignsAmount(): number {
        return this.getSiteDesigns().length - this.maxDisplayedSiteDesigns;
    }
}
